<template>
<p class="upload-img-tips">{{$t('Only_jpg_png_images_can_be_uploaded_and_should_not_exceed_10MB')}}</p>
</template>

<script>
export default {
  name: 'uploadImgTips'
};
</script>

<style lang="scss" scoped>
.upload-img-tips {
  color: #B9B9C3;
  line-height: 1.5!important;
  padding: 5px 0;
  padding-bottom: 10px;
  font-size: 12px;
}
</style>
